import { defineMessages } from 'react-intl';

const messages = defineMessages({
  twoWayTexting: {
    id: 'App.TwoWayTextingSetup.twoWayTexting',
    defaultMessage: 'Two-Way Texting',
  },
  twoWayTextingTooltip: {
    id: 'App.TwoWayTextingSetup.twoWayTextingTooltip',
    defaultMessage:
      'This setting is managed by Fortress. Please submit a support ticket for assistance or details.',
  },
  automatedProspectText: {
    id: 'App.TwoWayTextingSetup.automatedProspectText',
    defaultMessage: 'Automated Prospect Text',
  },
  automatedProspectTextTooltip: {
    id: 'App.TwoWayTextingSetup.automatedProspectTextTooltip',
    defaultMessage: 'Sends an automated text to newly created prospects.',
  },
  automatedProspectTextPreviewLabel: {
    id: 'App.TwoWayTextingSetup.automatedProspectTextPreviewLabel',
    defaultMessage: 'Preview message:',
  },
  automatedProspectTextPreview: {
    id: 'App.TwoWayTextingSetup.automatedProspectTextPreview',
    defaultMessage:
      '“Hi {prospectName}! Thank you for your interest in {propertyName}! ' +
      "We're excited to help you find your new home and are here to assist with any questions " +
      'about availability or the application process. ' +
      'Feel free to reply to this message—our team is happy to help get you started!”',
  },
  recertTextReminders: {
    id: 'App.LeaseSetup.recertTextReminders',
    defaultMessage: 'Recert Text Reminders',
  },
  recertTextRemindersTooltip: {
    id: 'App.LeaseSetup.recertTextRemindersTooltip',
    defaultMessage:
      'Turning this feature on, creates schedules based on household Recert Due Dates to begin sending ' +
      'Automated Recert Text Reminders to residents. Turning this feature off, will remove all scheduled ' +
      'reminders created and Automated Recert Text Reminders will no longer be sent to residents.',
  },
});

export default messages;
